import React from 'react';
import { Question, Serializer } from 'survey-core';
import { ReactQuestionFactory } from 'survey-react-ui';
import Terms from './terms';

// Custom question model for Terms and Conditions
class TermsModel extends Question {
  getType () {
    return 'terms';
  }
}

// Register the question model with SurveyJS
Serializer.addClass(
  'terms',
  [],
  function () {
    return new TermsModel('');
  },
  'question',
);

// React component for rendering
class TermsQuestion extends React.Component<any> {
  get question (): TermsModel {
    return this.props.question;
  }

  render () {
    return <Terms />;
  }
}

export const registerTermsQuestion = () => {
  // Register the React component
  ReactQuestionFactory.Instance.registerQuestion(
    'terms',
    (props) => {
      return React.createElement(TermsQuestion, props);
    },
  );
};
